(function() {
    //타겟 요소 셋팅
    var targetlist = ["#stepInput", "#topicBox", "#serviceMenu"];
    
    var observeroptions = {
            root: null,
            rootMargin: '0px'
            //threshold: 0.3
        };
        
    // options에 따라 인스턴스 생성
    var observer = new IntersectionObserver(function(entries,observer) {
          entries.forEach(function(entry) {
                // 루트 요소와 타겟 요소가 교차하면 dataset에 있는 이미지 url을    타겟요소의 src 에 넣어준다.
                if (entry.isIntersecting) {
                    if(entry.target.id == 'stepInput'){
                        observeSend('stepInput');
                    }else if(entry.target.id == 'topicBox'){
                        observeSend('제품에 나타난 증상을 선택해주세요');
                    }else if(entry.target.id == 'manualSection'){
                        observeSend('제품 사용설명서예요');
                    }else if(entry.target.id == 'driverSection'){
                        observeSend('드라이버예요');
                    }else if(entry.target.id == 'serviceMenu'){
                        observeSend('제품 문제가 아직 해결되지 않았나요? 다른 서비스를 이용해 보세요.');
                    }else if(entry.target.id == 'serviceMenu2'){
                        observeSend('제품 문제가 아직 해결되지 않았나요? 다른 서비스를 이용해 보세요.');
                    }
                    //타겟 요소 관찰 종료(1회만 보내기 위한 처리)
                      observer.unobserve(entry.target);
                }
              })
            }, observeroptions);
    //옵저버 처리
    function observeSend(eventLabel) {
        var tabTitle = "";
        // if ($('#solutions-tab').find('a[aria-controls="tab3"]').attr('aria-selected') == 'true'){
        //     tabTitle = "문제 해결 Q&A";
        // }else{
            tabTitle = "다운로드 센터";
        // }
        dataLayer.push({
            'event': 'customEvent',
            'ga4event': 'custom_event',
            'customEventCategory': '완독률',
            'customEventAction': '완독률 - 스스로해결 리스트',
            'customEventLabel': tabTitle +"-"+ eventLabel
        });
    };
    var filterTemplate = '<li>' +
                            '<span class="rdo-wrap btn-type4">'+
                                '<input type="radio" name="topicrdo" id="topic{{index}}"  data-name="{{name}}" value="{{code}}" data-group="{{code}}">' +
                                '<label for="topic{{index}}"><span>{{name}}</span></label>' +
                            '</span>' +
                        '</li>';

    var filterSubTemplate = '<option data-code="{{code}}" data-text="{{name}}" value="{{name}}">{{name}}</option>';
    
    var filterHeadTemplate =
        '<li>'+
        '<span class="rdo-wrap btn-type4">'+
        '<input type="radio" name="topicrdo" id="topicrdo0" value="" data-group="A">'+
        '<label for="topicrdo0">'+
        '<span>{{name}}</span>'+
        '</label>'+
        '</span>'+
        '</li>';
        
        
    var filterOptionTemplate =
        '{{# if (active == true) { #}}' +
        '<option value="{{code}}" selected>{{name}}</option>' +
        '{{# } else { #}}' +
        '<option value="{{code}}">{{name}}</option>' +
        '{{# } #}}';

    var solutionsTemplate = 
        '<li>'+
        '<a href="{{url}}">'+
        '<div class="category">'+
        '<span class="txt">{{subCategoryNm}}</span>'+
        '</div>'+
        '<div class="title">'+
        '<span class="txt">{{#raw title}}'+
        '{{# if (typeof video != "undefined" && video === true) { #}}' +
        '<span class="icon-movie"><em class="blind">동영상 컨텐츠</em>'+
        '</span>'+
        '{{# } #}}' +
        '</div>'+
        '<div class="info">'+
        '<span class="date">{{date}}</span>'+
        '</div>'+
        '<div class="hits">'+
        '<span>{{view}}</span>'+
        '</div>'+
        '</a>'+
        '</li>';

    var keywordsTemplate = 
    '{{# if (typeof sympCodeThree != "undefined" && sympCodeThree != "전체") { #}}' +
    '“<span class="point">{{sympCodeThree}}</span>”' +
    '{{# } else if (typeof keyword != "undefined" && keyword != "") { #}}' +
    ' “<span class="point">{{keyword}}</span>”' +
    '{{# } else { #}}' +
    ' “<span class="point">전체</span>”' +
    '{{# } #}}';	

    var recommProductItemTemplate =         
        '<div class="slide-conts ui_carousel_slide">' +
            '<div class="item">' +
                '<a href="{{modelUrlPath}}" class="item-inner">' +
                    '<div class="product-image">' +
                        '<img src="{{mediumImageAddr}}" alt="">' +
                    '</div>' +
                    '<div class="product-info">' +
                        '{{# if(bestFlag == "Y" || newFlag == "Y") { #}}' +
                        '<div class="flag-wrap bar-type">' +
                            '{{# if(newFlag == "Y") { #}}' +
                            '<span class="flag">신제품</span>' +    
                            '{{# } #}}' +
                            '{{# if(bestFlag == "Y") { #}}' +
                            '<span class="flag">베스트</span>' +    
                            '{{# } #}}' +                
                        '</div>' +
                        '{{# } #}}' +
                        '<div class="product-name">' +
                            '<p class="name">{{modelDisplayName}}</p>' +
                            '<p class="model">{{modelName}}</p>' +
                        '</div>' +
                    '</div>' +
                '</a>' +
            '</div>' +
        '</div>';
    var serviceMenuTemplate = 
        '<li>' +
            '<a href="{{url}}">' +
                '<div class="icon"><img src="{{imgUrl}}" alt="" aria-hidden="true"></div>' +     
                '<p class="tit">{{name}}</p>' +
                '<p class="desc">{{desc}}</p>' +
            '</a>' +
        '</li>';
    var updateBannerTemplate = 
        '<div class="info-banner">' +
            '{{#each (item, index) in updateBanner}}' +
            '<a href="{{item.url}}" class="btn dark-gray size" target="_blank"><span>{{item.name}}</span></a>' +
            '{{/each}}' +
        '</div>';
    var detect = vcui.detect;
    
    $(window).ready(function() {

        var solutions = {
            options: {
                keywords: [],
                topic: '',
                topicNm: '전체',
                subTopic: '',
                subTopicNm: '전체',
                sympCodeThree:'',
                sympNameThreeNm:'전체',
                sort: 'update',
                page: 1,
                research: false,
                category: '',
                categoryNm: '',
                subCategory: '',
                subCategoryNm: '', 
                modelCode: '', 
                productCode: '',
                video: ''
            },
            initialize: function() {
                var self = this;					

                self.$cont = $('.contents');
				self.$selectedModelBar = self.$cont.find('.goods-selected-wrap'); //선택된 제품정보
				self.$myModelWrap = self.$cont.find('.my-product-wrap'); // 보유제품
				self.$prodSearchWrap = self.$cont.find('.prod-search-wrap'); // 제품정보 입력
                self.$tabProd = self.$cont.find('#tabs-prod'); // 탭

                self.$stepArea = self.$cont.find('.step-area');
                self.$stepInput = self.$stepArea.find('#stepInput');

                //서비스 화면
                self.$contentsjobDiv = self.$cont.find('#contents-job');

                //모델 검색 영역
                self.$modelBox = self.$stepArea.find('#model-box');
                self.$modelSearch = self.$modelBox.find('.ui_search_model');
                self.$modelInput = self.$modelSearch.find('input');
                self.$modelBtn = self.$modelSearch.find('.btn-search');

                
                //키워드 검색 영역
                self.$solutionsWrap = $('.solve-sch-wrap');
                self.$keywordWrap = self.$solutionsWrap.find('.ui_search');
                self.$keywordInput = self.$solutionsWrap.find('#keyword');
                self.$keywordBtn = self.$solutionsWrap.find('.keyword-search .btn-search');
                self.$searchrecommend = self.$solutionsWrap.find('.keyword-search .search-recommend');
                
                //증상
                self.$topicBox = self.$cont.find("#topicBox");
                self.$solutionsFilter = self.$topicBox.find('.section-box .topic-wrap .topics .rdo-list');  //증상 1 리스트
                self.$solutionsFilterSubtopic = self.$topicBox.find('.section-box .topic-wrap .sub-topic');
                self.$solutionsFilterSub1 = self.$solutionsFilterSubtopic.find('#stopic01');  //증상 2 리스트
                self.$solutionsFilterSub2 = self.$solutionsFilterSubtopic.find('#stopic02');  //증상 3 리스트
                
                //검색 결과 영역
                self.$solutionsResult = self.$cont.find('.solution-result-wrap');  
                self.$totalCount = self.$solutionsResult.find('#totalCount');
                self.$solutionsPagination = self.$solutionsResult.find('.pagination');
                self.$solutionsSort = self.$solutionsResult.find('#sort');
                self.$solutionsVideo = self.$solutionsResult.find('#video');
                //self.$solutionsVideo.prop('checked', false); //동영상만 리셋 // BTOCSITE-57165 [스스로해결] 이전페이지 조회 시 페이징 정보 누락
                
                //self.$selectTopic = self.$solutionsWrap.find('#topic');
                //self.$selectSubTopic = self.$solutionsWrap.find('#subTopic');


                self.$bannerProduct = self.$cont.find('#recommProduct');
                self.$bannerMenu = self.$cont.find('#serviceMenu');
                self.$bannerMenu2 = self.$cont.find('#serviceMenu2');
                

                self.setting();
                self.bindEvent();

                if (!self.isPSP) {
                    vcui.require(['support/common/searchModelNew.min'], function () {
                        self.$cont.vcSearchModelNew({model:self.param});
                    });
                } else {
                    $.extend(self.param, {
                        category:      $('#category').val(),
                        categoryNm:    $('#categoryNm').val(), 
                        subCategory:   $('#subCategory').val(),
                        subCategoryNm: $('#subCategoryNm').val(), 
                        modelCode:     $('#modelCode').val(),
                        productCode:   $('#productCode').val()
                    });
                }

                // BTOCSITE-51762 홈페이지 문제해결 개선 요청
                // BTOCSITE-57165 [스스로해결] 이전페이지 조회 시 페이징 정보 누락
                // var sort = lgkorUI.getParameterByName('sort');
                // var page = lgkorUI.getParameterByName('page');
                // var keyword = lgkorUI.getParameterByName('searchKeyword');
                // var topicNm = lgkorUI.getParameterByName('topicNm');
                // var subTopicNm = lgkorUI.getParameterByName('subTopicNm');
                // var sympNameThreeNm = lgkorUI.getParameterByName('sympNameThreeNm');
                
                var paramData = {};
                var url = location.search;
                if (url.indexOf("?") > -1) {
                    var search = url.substring(1);
                    //var searchObj = vcui.uri.parseQuery(location.search);
                    var searchObj = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

                    for (var key in searchObj) {
                        if (key == 'searchKeyword') {
                            paramData['keywords'] = [];
                            paramData['keywords'].push(decodeURIComponent(searchObj.searchKeyword));
                            
                        } else {
                            paramData[key] = decodeURIComponent(searchObj[key]);
                        }
                    }
                }
                $.extend(self.param, paramData);

                // if(page){
                // 	$.extend(self.param, {
                // 		page: page,
                // 	});
                // }
                // if(vcui.array.include(['update', 'popular'], sort)){
                // 	$.extend(self.param, {
                //         sort: sort,
                //     });
                // 	self.$solutionsSort.vcSelectbox('value', sort);
                // }

                if(self.param.sort) {
                    self.$solutionsSort.val(self.param.sort).prop('selected', true);
                }

                if(self.param.video == 'Y') {
                    self.$solutionsVideo.prop('checked', true); 
                }

                if(self.param.keywords){
                    self.$keywordInput.val(self.param.keywords);
                    self.$solutionsWrap.find('.ui_input_clearbutton').vcInputClearButton('updateVal', self.param.keywords);
                }

                // url 파라메타에서 받아온 paramData 값이 있을 경우 
                // if(paramData.topicNm && paramData.subTopicNm && paramData.sympNameThreeNm){
                //     setTimeout(function(){
                //         // self.$solutionsFilter.find('li').eq(0).find('.rdo-wrap').trigger('click');
                //         // self.$solutionsFilter.find('li').eq(0).find('.rdo-wrap input[name="topicrdo"]').prop('checked', true);
                //         self.$solutionsFilter.find('li input[id="'+paramData.topicNm+'"]').trigger('click');

                //         self.$solutionsFilterSub1.find('select').vcSelectbox('value', paramData.subTopicNm);
                //         self.$solutionsFilterSub1.find('select').vcSelectbox('update');

                //         self.$solutionsFilterSub2.find('select').vcSelectbox('value', paramData.sympNameThreeNm);
                //         self.$solutionsFilterSub2.find('select').vcSelectbox('update');
                //     }, 1000)
                // }
                
                //self.$selectedModelBar.hide();    //jslee 보유 제품 선텍시 바컨트롤
                //self.$selectedModelTabBar.show();   //jslee 보유 제품 선텍시 바컨트롤
                self.$contentsjobDiv.hide();
                
                
                self.$keywordWrap.search({
                    template: {
                        autocompleteList: '<ul>{{#each (item, index) in list}}<li><a href="{{item.url}}"><div class="list-head"><strong class="list-category">{{item.subCategory}}</strong><span class="list-sub-category">{{item.subTopic}}</span></div><div class="list-desc">{{item.contTitle}}</div></a></li>{{/each}}</ul>',
                        recentlyList: '<li><a href="#">{{keyword}}</a><button type="button" class="btn-delete"><span class="blind">삭제</span></button></li>',
                        keywordList: '<li><a href="#">{{keyword}}</a></li>'
                    }
                });
                
                self.$solutionsPagination.pagination();       
                
            },
            setting: function() {
                var self = this;
                var url = location.search;
                var data = $.extend({}, self.options);
                self.resultUrl = '/support/solutions/searchSolutions.lgajax';
                self.solutionsUrl = self.$solutionsWrap.data('solutionsUrl');
                self.isPSP = self.$cont.hasClass('psp');
                topicParam = {
                    topic : $('input#topic').val(),
                    topicNm : $('input#topicNm').val(),
                    subTopic : $('input#subTopic').val(),
                    subTopicNm : $('input#subTopicNm').val(),
                    sympCodeThree : $('input#sympCodeThree').val(),
                    sympNameThreeNm	: $('input#sympNameThreeNm').val()	
                }
                $.extend(data,topicParam)
                self.param = data;
            },
            completeModel: function() {
                var self = this;
                var model = $.extend(true, {}, self.param) // deepCopy 일부 불필요 파라미터 제거용
                //delete model.modelCode;
                //delete model.productCode;
                model.sympTree="Y";
                model.modelCode=$('#modelCode').val();    //보유제품 선택시 모댈코드 
                // if($('#preLoad').val() == "Y"){     //모댈코드 샛팅된상테로 조회시 화면 컨트롤
                //     self.$selectedModelBar.show();
                //     self.onLoadTabControl();  //스스로 해결진입 기준으로 탭 표시
                // }

                var sympPreLoad = false;
                if(model.topic != ""){
                    sympPreLoad = true;
                    model.topic = '';
                    model.subTopic = '';
                    model.sympCodeThree = '';
                    model.topicNm = '전체';
                    model.subTopicNm = '전체';
                    model.sympNameThreeNm = '전체';
                }

                // /searchSolutions.lgajax
                lgkorUI.showLoading();
                lgkorUI.requestAjaxData(self.resultUrl, model, function(result) {
                    var data = result.data,
                        param = result.param;
                    self.sympTree = result.sympTree;
                    self.setFilter();
                    self.setBanner(data);
                    self.setPopularKeyword(data);
                    self.setSolutionsList(data);
                    self.setKeyword(param);  //검색조건 키워드 표시 변경
                    
                    if(sympPreLoad){
                        self.requestData();
                        self.setSympPreLoad(); //preLoad 일때 증상 셋팅

                    }else{
                        lgkorUI.hideLoading();
                    }

                }, 'GET'); // BTOCSITE-31644 고객지원 > 검색엔진 성능 향상/고객지원 페이지 내 검색 기능 수정 요청
                
                
                
                self.$cont.vcSearchModelNew('updateSummary', {
                    product: [model.categoryNm, model.subCategoryNm, model.modelCode],
                    isMyProduct: $('#isMyProduct').val(),
                    reset: 'product'
                });
                
            },
            
            setBanner: function(data) {
                var self = this;
                // var productArr = data.recommProduct instanceof Array ? data.recommProduct : [];
                var menuArr = data.serviceMenu instanceof Array ? data.serviceMenu : [];
                var updateArr = data.updateBanner instanceof Array ? data.updateBanner : [];
                var $productSlider = self.$bannerProduct.find('.product-slider'),
                    $menuList = self.$bannerMenu.find('.service-list');
                    // $menuList2 = self.$bannerMenu2.find('.service-list');
                

                // if (productArr.length) {
                //     var html = '';
                //     productArr.forEach(function(item) {
                //         html += vcui.template(recommProductItemTemplate, item);
                //     });

                //     $productSlider.find('.slide-track').html(html);
                //     if (!$productSlider.hasClass('ui_carousel_initialized')) {
                //         lgkorUI.initProductSlider();
                //     } else {
                //         $productSlider.vcCarousel('reinit');
                //     }
                //     self.$bannerProduct.show();
                //     html = '';
                // }

                if (menuArr.length) {
                    var html = '';
                    menuArr.forEach(function(item) {
                        if(item.url == "/support/service-engineer-reservation" 
                        || item.url == "/support/request-call-reservation"
                        || item.url == "/support/visit-center-reservation"){
                              item.url += "?category="+ $('#category').val()
                              + "&subCategory="+ $('#subCategory').val()
                              + "&categoryNm=" + $('#categoryNm').val()
                              + "&subCategoryNm=" + $('#subCategoryNm').val()
                              + "&productCode=" + $('#productCode').val()
                              + "&mktModelCd=" + $('#modelCode').val()
                              + "&cstFlag=Y";
                            
                        }
                        html += vcui.template(serviceMenuTemplate, item);
                    });

                    $menuList.html(html);
                    self.$bannerMenu.show();
                    
                    // $menuList2.html(html);
                    // self.$bannerMenu2.show();
                }
                /*
                if (updateArr.length && !detect.isMobile) {
                    var html = '';
                    html = vcui.template(updateBannerTemplate, data);
                    self.$solutionsWrap.prepend(html);
                }
                */
            },
            
            setPopularKeyword: function(data) {
                var self = this;
                var arr = data.popularKeyword instanceof Array ? data.popularKeyword : [];
                //search-desc
                //this.$keywordWrap.search('setPopularKeyword', arr);
                
                var deschtml = '';
                arr.forEach(function(item){
                    deschtml += '<dd><a href="" linkid="keyword">#'+item+'</a></dd>';
                });
                deschtml =  '<dl><dt>추천 검색 키워드</dt>'+deschtml+'</dl>'
                self.$searchrecommend.html(deschtml);
                
                if(self.param.topicNm === ''){
                    self.param.topicNm = '전체';
                }
                if(self.param.subTopicNm === ''){
                    self.param.subTopicNm = '전체';
                }
                if(self.param.sympNameThreeNm === ''){
                    self.param.sympNameThreeNm = '전체';
                }

                var html = vcui.template(keywordsTemplate, {
                    topic: self.param.topicNm,
                    subTopic: self.param.subTopicNm,
                    sympCodeThree: self.param.sympNameThreeNm,
                    keyword: self.param.keywords[0]
                });
                html += ' 검색 결과';
                self.$solutionsResult.find('.tit-wrap .sub-tit').html(html);  //검색 타이틀  “전체” 검색 결과
                
            },
            
            setKeyword: function() {
                var self = this;
                var html = '';
                
                html = vcui.template(keywordsTemplate, {
                    topic: self.param.topicNm,
                    subTopic: self.param.subTopicNm,
                    sympCodeThree: self.param.sympNameThreeNm,
                    keyword: self.param.keywords[0]
                });
                html += ' 검색 결과';
                self.$solutionsResult.find('.tit-wrap .sub-tit').html(html);  //검색 타이틀  “전체” 검색 결과
            },
            setFilter: function() {
                var self = this;
                var param = self.param,
                    filterArr = self.sympTree.sympList1 instanceof Array ? self.sympTree.sympList1 : [],
                    htmlPC = '';
                if (filterArr.length) {
                    self.$solutionsFilter.empty();
                    self.$solutionsFilter.html(vcui.template(filterHeadTemplate, {}));

                    filterArr.forEach(function(item, i) {
                        if(i==0){
                            return;	
                        }
                        item.index = i.toString(); // id값 으로 index 추가
                        item.active = item.name == param.topicNm ? true : false; 
                        htmlPC += vcui.template(filterTemplate, item);
                    });
                    self.$solutionsFilter.html(htmlPC);
                } else {
                    self.$solutionsFilter.empty();
                }
            },
            
            setSolutionsList: function(data) {
                var self = this;
                var $listWrap = self.$solutionsResult.find('.section-box'),  //조회 영역
                    $pagination = self.$solutionsResult.find('.section-box .pagination'),
                    $noData = self.$solutionsResult.find('.section-box .no-data'),
                    $searchMore = self.$keywordWrap.find('.search-more'),
                    $listsorting = self.$solutionsResult.find('.list-sorting.type-line');
                
                var arr = data.listData instanceof Array ? data.listData : [],
                    html = '';
                    
                $listWrap.find('.solution-result-list').empty();

                if (arr.length) {
                    arr.forEach(function(item) {
                        
                        item.title = item.title.replace(/¶HS¶/g, '<span class="keyword">');
                        item.title = item.title.replace(/¶HE¶/g, '</span>');
                        item.view = vcui.number.addComma(item.view);
                        
                        $.extend(item, {
                        category:      $('#category').val(),
                        categoryNm:    $('#categoryNm').val(), 
                        subCategory:   $('#subCategory').val(),
                        subCategoryNm: $('#subCategoryNm').val(), 
                        modelCode:     $('#modelCode').val(),
                        productCode:   $('#productCode').val()
                        });
                        
                        html += vcui.template(solutionsTemplate, item);
                    });
                    html = '<ul>'+html + '</ul>';
                    $listWrap.find('.solution-result-list').html(html);
                    $pagination.pagination('update', data.listPage);
                
                    //$listWrap.show();
                    $listWrap.find(".solution-result-list").show();

                    //$listsorting.show();
                    $pagination.show();
                    $noData.hide();


                    
                } else {
                    //$listWrap.show();
                    //$listsorting.hide();
                    $pagination.hide();
                    self.$solutionsResult.find('.tit-wrap .sub-tit').html("검색 결과");  //검색 타이틀  “전체” 검색 결과
                    $noData.show();
                    $searchMore.hide();
                    $searchMore.find('input[type=checkbox]').prop('checked', false);
                    
                }
                // BTOCSITE-51762 LGE.COM 홈페이지 문제해결 개선 요청
                if(typeof data.listPage !== 'undefined'){					
                    self.$totalCount.html('전체 <em>'+ data.listPage.totalCount + '</em> 건');  //조회 건수 표시
                }
                //self.$solutionsResult.find('#solutionsCount').html(data.listPage.totalCount);
                self.scrollDefSet();
            },
            scrollDefSet: function(){
                observer.disconnect();
                targetlist.forEach(function(target) {
                    // 타겟 요소 관찰 시작
                    var target = document.querySelector(target);
                    observer.observe(target);
                });
            },	
            
            /*
            selectFilterMobile: function(code) {
                var self = this;

                self.$selectTopic.val(code);
                self.$selectSubTopic.find('option:not(.placeholder)').remove();
                self.$selectSubTopic.prop('disabled', false);
                self.$selectTopic.vcSelectbox('update');
                self.$selectSubTopic.vcSelectbox('update');
            },
            selectSubFilterMobile: function(code) {
                var self = this;

                self.$selectSubTopic.val(code);
                self.$selectSubTopic.vcSelectbox('update');
            },
            */
            requestData: function() {
                var self = this;
                var param = $.extend(true, {}, self.param);

                //searchSolutionsList.lgajax
                lgkorUI.showLoading();
                lgkorUI.requestAjaxData(self.solutionsUrl, param, function(result) {
                    var data = result.data;
                    self.setSolutionsList(data);
                    self.setKeyword();

                    if (self.param.keywords.length) {
                        self.$keywordInput.val(self.param.keywords[0]);
                        // BTOCSITE-64549 [모니터링 G][APP] 필터 조건에 따라 검색 페이지가 다시 로드되지만 검색창의 콘텐츠에는 X 버튼 사라지는 현상
                        self.$solutionsWrap.find('.ui_input_clearbutton').vcInputClearButton('updateVal', self.param.keywords[0]);
                    }
                    
                    lgkorUI.hideLoading();
                }, 'GET'); // BTOCSITE-31644 고객지원 > 검색엔진 성능 향상/고객지원 페이지 내 검색 기능 수정 요청
            },
            resetFilter: function() {
                var self = this;

                self.resetSubFilter();
                self.$solutionsFilter.find('.filter-list > li:first-child').addClass('on');
            },
            resetSubFilter: function() {
                var self = this;

                self.$solutionsFilter.find('.open, .on').removeClass('open on');
                self.$solutionsFilter.find('.sub-depth').remove();
            },
            setSympPreLoad: function() {
                var self = this;
                var topicNm = self.param.topicNm;
                var subTopicNm = self.param.subTopicNm;
                var sympNameThreeNm = self.param.sympNameThreeNm;

                if(topicNm && subTopicNm && sympNameThreeNm){
                    self.$solutionsFilter.find('li input[data-name="'+topicNm+'"]').trigger('click');
                    self.$solutionsFilterSub1.find('.ui_selectbox').vcSelectbox('value', subTopicNm);
                    self.$solutionsFilterSub1.find('.ui_selectbox').vcSelectbox('update');
                    self.$solutionsFilterSub2.find('.ui_selectbox').vcSelectbox('value', sympNameThreeNm);
                    self.$solutionsFilterSub2.find('.ui_selectbox').vcSelectbox('update');
                }
            },
            reset: function() {
                var self = this,
                    data = $.extend({}, self.options);
                self.param = data;

                $.extend(self.param, {
                    keywords: []
                });

                self.$cont.find('.ui_input_clearbutton').vcInputClearButton('updateVal', '');
                
				self.$modelBox.find('#categorySelect').find('option:first-child').prop('selected', true);
				self.$modelBox.find('#categorySelect').vcSelectbox('update');
				self.$modelBox.find('#subCategorySelect').find('option:not(.default)').remove();
				self.$modelBox.find('#subCategorySelect').vcSelectbox('update');
                $('#prdGrp02').hide(); //서브카테고리

                $('input#topic').val('');
                $('input#topicNm').val('전체');
                $('input#subTopic').val('');
                $('input#subTopicNm').val('전체');
                $('input#sympCodeThree').val('');
                $('input#sympNameThreeNm').val('전체');
                self.$solutionsFilter.empty();
                self.$solutionsFilterSub1.hide();
                self.$solutionsFilterSub2.hide();

                $('#stopic01').find('.ui-selectbox-wrap').find('.ui-selectbox-list').empty();
                $('#stopic02').find('.ui-selectbox-wrap').find('.ui-selectbox-list').empty();
                self.$solutionsSort.val(data.sort).vcSelectbox('update');
                self.$keywordWrap.search('reset');
                self.$selectedModelBar.hide();
                $('#recommProduct').hide();
                $('#serviceMenu').hide();
                $('.info-banner').remove();

                self.$solutionsVideo.prop('checked', false); 
                                    
                self.$tabProd.show();
                self.$myModelWrap.show();
                self.$contentsjobDiv.hide();
                

            },
            onLoadTabControl: function(){
                var linkTab = $('.container').attr('linkTabCode');	
                if(linkTab == 1){
                    $('#solutions-tab').find('a[aria-controls="tab3"]').trigger('click');
                }else{
                    $('#solutions-tab').find('a[aria-controls="tab4"]').trigger('click');
                }
            },
            // downloadSearchChk: function(){
            //     if( $('#modelCode').val().length > 0){
            //         $('#modelcodeSearch').hide();
            //     }else{
            //         $('#modelcodeSearch').show();
            //     }
            // },
            bannerToggle: function(modelType){

                var $banner = $('.banner-wrap.toggle-banner');

                if( modelType == undefined) {
                    $banner.hide();
                }

                if( modelType == "CT50019564" || modelType == "CT50019585") {
                    $banner.show();
                } else {
                    $banner.hide();
                }
            },
            bindEvent: function() {
                var self = this;

				lgkorUI.hideLoading();

                $('.solution-result-list').on('click', 'a', function() {
                    
                    // BTOCSITE-51762 LGE.COM 홈페이지 문제해결 개선 요청                       
                    var url = $(this).attr('href');
                    var param = url.substr(url.indexOf('?'));
                    var data = history.state;
                    
                    url = location.pathname + param;
                    window.history.pushState('', '', url);

                });
                
                 // BTOCSITE-51762 LGE.COM 홈페이지 문제해결 개선 요청
                window.addEventListener("popstate", function(evt) {
                    window.history.pushState('', '', location.pathname);
    
                    self.$selectedModelBar.find('.btn-reset').trigger('click');
                    
                }, false);
                
                // BTOCSITE-51762 LGE.COM 홈페이지 문제해결 개선 요청
                self.$selectedModelBar.on('click', '.btn-reset', function() {
                    self.reset();
                });

                self.$bannerProduct.on('click', 'a', function() {
                    lgkorUI.setAcecounter('www.lge.co.kr/acecount/solutionsPartsClick.do', '/acecount/solutionsPartsClickm.do');
                });

                self.$cont.find('.result-box').on('click', '.item', function() {
                    lgkorUI.setAcecounter('www.lge.co.kr/acecount/solutionsListClick.do', '/acecount/solutionsListClickm.do');
                    lgkorUI.historyBack(this);
                });
                

                // BTOCSITE-55571 고객지원 > 스스로 해결 콘텐츠 Survey 화면 변경 및 데이터 Tracking
                // 카테고리 선택 후 productCode를 받아온 후 searchSolutions.lgajax 호출
                vcui.PubSub.on('completeSummary', function (e, data) {
                    $.extend(self.param, {
                        category:      $('#category').val(),
                        categoryNm:    $('#categoryNm').val(), 
                        subCategory:   $('#subCategory').val(),
                        subCategoryNm: $('#subCategoryNm').val(), 
                        modelCode:	   $('#modelCode').val(),
                        productCode:   $('#productCode').val(),
                        salesModelCode:$('#salesModelCode').val()
                    });

                    self.completeModel();
                    
                    self.$tabProd.hide();
                    self.$prodSearchWrap.hide();
                    self.$contentsjobDiv.show();
                    self.$selectedModelBar.show();
                });

                self.$cont.on('complete', function(e, data) { 
                    
                    $.extend(self.param, data);
                    // BTOCSITE-57165 [스스로해결] 이전페이지 조회 시 페이징 정보 누락
                    // var url = location.search;
                    // if (url.indexOf("?") > -1) {
                    // 	var search = url.substring(1);
                    // 	var searchObj = vcui.uri.parseQuery(location.search);
                    // 	for (var key in searchObj) {
                    // 		paramData[key] = decodeURIComponent(searchObj[key]);
                    // 	}
                    // }
                    // $.extend(true, self.param, paramData);
                    
                    // if(self.param.video == 'Y') {
                    // 	self.$solutionsVideo.prop('checked', true); 
                    // }


                    self.completeModel();
                    self.$myModelWrap.hide();
                    self.$tabProd.hide();
                    self.$prodSearchWrap.hide();
                    self.$contentsjobDiv.show();
                    self.$selectedModelBar.show();

                }).on('reset', function(e) {
                    self.reset();
                });
                
                self.$searchrecommend.on('click','a[linkid="keyword"]', function(e, data) { //검색어 선택검색
                    //인식됨
                    e.preventDefault();
                    var text = e.target.innerHTML.replace("#","").split('<')[0];
                    self.param.keywords=[text];
                    self.$keywordInput.val(text)
                    
                    //키워드 검색 시 기존 증상 데이터 리셋 
                    $('input[name="topicrdo"]:checked').prop("checked",false)
                    $('.sub-topic').hide()

                    self.param.topic = "";
                    self.param.topicNm = "전체";
                    self.param.subTopic= "";
                    self.param.subTopicNm= "전체";
                    self.param.sympCodeThree = "";
                    self.param.sympNameThreeNm = "전체";
                    self.param.page = 1;
                      
                    self.requestData();
                });

                // 키워드 삭제
                self.$solutionsResult.find('.tit-wrap .sub-tit').on('click', '.btn-delete', function() {
                    self.$keywordInput.val('').trigger('update');
                    self.param.keywords = [];
                    self.param.keyword = '';
                    self.requestData();
                });

                //증상 1댑스 클릭
                self.$solutionsFilter.on('click', '.rdo-wrap', function(e, data) {
                    self.$solutionsFilterSub1.hide();
                    self.$solutionsFilterSub2.hide();
                    self.$solutionsFilterSub1.empty();
                    self.$solutionsFilterSub1.empty();
                    $('#stopic01').find('.ui-selectbox-wrap').find('.ui-selectbox-list').empty();
                    $('#stopic02').find('.ui-selectbox-wrap').find('.ui-selectbox-list').empty();

                    var value = $(this).find('input[type=radio]').attr('value');
                    var name = $(this).find('input[type=radio]').data('name');
                    var param = {
                            topic:value,
                            topicNm:name,
                            subTopic:'',
                            subTopicNm:'전체',
                            sympCodeThree: '',
                            sympNameThreeNm: '전체',
                            productCode:  $('#productCode').val(),
                            video: '',
                    };
                    $.extend(self.param, param);
                    var htmlPC= "";
                    var select4 = self.$cont.find("#stopic01");
                    if(select4 != null){
                        select4.html("증상을 선택해주세요");
                    }
                    var select5 = self.$cont.find("#stopic02");
                    if(select5 != null){
                        select5.html("세부 증상을 선택해주세요");
                    }
                    self.$solutionsVideo.prop('checked', false);
                    var arr = self.sympTree.sympList2 instanceof Array ? self.sympTree.sympList2 : [];
                    
                    arr.forEach(function(item, i) {
                        if(i==0 || item.highCode != value){
                            return;	
                        }
                        item.subType = true;
                        item.active = item.name == param.subTopicNm ? true : false; 
                        htmlPC += vcui.template(filterSubTemplate, item);
                    });
                    
                    htmlPC = '<option data-code="" data-text="" value="all" class="placeholder">증상을 선택해주세요</option>' + htmlPC;
                    htmlPC = '<select class="ui_selectbox" title="증상선택">'+htmlPC+'</select>';
                    self.$solutionsFilterSub1.html(htmlPC);
                    self.$solutionsFilterSubtopic.show();
                    self.$solutionsFilterSub1.show();
                    self.$solutionsFilterSub1.find('select').vcSelectbox();
                    $('#stopic01').find('.ui-selectbox-wrap').addClass('on');
                    $('#stopic01').find('.ui-selectbox-wrap').find('.ui-selectbox-list').show();
                });
                //증상 2 선택
                self.$solutionsFilterSub1.on('change' ,'.ui_selectbox' , function(e, data) {
                    var value = self.$solutionsFilterSub1.find("option:selected").attr("data-code");
                    var name = self.$solutionsFilterSub1.find("option:selected").attr("data-text");
                    var param = {
                            subTopic:value,
                            subTopicNm:name,
                            sympCodeThree: '',
                            sympNameThreeNm: '전체'
                    };
                    $.extend(self.param, param);
                    var htmlPC = "";
                    var select5 = self.$cont.find("#stopic02");
                    if(select5 != null){
                        //select5.attr("class", "select-wrap");
                        select5.html("세부 증상을 선택해주세요");
                    }
                    self.$solutionsVideo.prop('checked', false);
                    var arr = self.sympTree.sympList3 instanceof Array ? self.sympTree.sympList3 : [];
                    
                    //BTOCSITE-59670 고객지원 > 증상 선택시 2depth와 3depth 동일 증상이면 선택 예외처리 요청
                    var newArr = vcui.array.filter(arr, function(item, index) {
                        return item.name !== '전체' && item.highCode === value;
                       });
                    
                    newArr.forEach(function(item, i) {
                        //if(i==0 || item.highCode != value){
                        //	return;	
                        //}
                        item.subType = true;
                        item.active = item.name == param.subTopicNm ? true : false; 
                        htmlPC += vcui.template(filterSubTemplate, item);
                    });
                    
                    htmlPC = '<option data-code="" data-text="" value="all" class="placeholder">증상을 선택해주세요</option>' + htmlPC;
                    htmlPC = '<select class="ui_selectbox" title="증상선택">'+htmlPC+'</select>';
                    self.$solutionsFilterSub2.html(htmlPC);
                    self.$solutionsFilterSubtopic.show();
                    self.$solutionsFilterSub2.show();
                    self.$solutionsFilterSub2.find('select').vcSelectbox();
                    
                      //BTOCSITE-59670 고객지원 > 증상 선택시 2depth와 3depth 동일 증상이면 선택 예외처리 요청
                    var timeout = null;
                    if(newArr.length === 1) {                        	
                        self.$solutionsFilterSub2.find('select').vcSelectbox('selectedIndex', 1, true);
                        clearTimeout(timeout);
                        timeout = setTimeout(function() {
                            self.$solutionsFilterSub2.find('select').vcSelectbox('update');
                        }, 10);
                    }
                    
                    $('#stopic02').find('.ui-selectbox-wrap').addClass('on');
                    $('#stopic02').find('.ui-selectbox-wrap').find('.ui-selectbox-list').show();
                });
                self.$solutionsFilterSub2.on('change', '.ui_selectbox', function(e, data) { //증상3 선택
                    var value = self.$solutionsFilterSub2.find("option:selected").attr("data-code");
                    var name = self.$solutionsFilterSub2.find("option:selected").attr("data-text");
                    self.$solutionsVideo.prop('checked', false);
                    self.param.keywords = [];
                    self.param.keyword = '';
                    var param = {
                            sympCodeThree:value,
                            sympNameThreeNm:name,
                            page:1, //page 초기화
                            keywords : [] // 키워드 초기화
                    };
                    $.extend(self.param, param);
                    self.requestData();
                });

                // 증상 선택 돌아가기
                self.$solutionsFilter.on('click', '.btn-back', function() {
                    var data = self.param;
                    var param = {
                        keywords: data.keywords,
                        category: data.category,
                        categoryNm: data.categoryNm,
                        subCategory: data.subCategory,
                        subCategoryNm: data.subCategoryNm,
                        modelCode: data.modelCode,
                        productCode: data.productCode,
                        keywords: self.param.keywords,
                        keyword: self.param.keyword
                    };

                    lgkorUI.showLoading();
                    lgkorUI.requestAjaxData(self.solutionsUrl, param, function(result) {
                        var data = result.data;

                        self.setFilter(data);
                        lgkorUI.hideLoading();
                    },'GET'); // BTOCSITE-31644 고객지원 > 검색엔진 성능 향상/고객지원 페이지 내 검색 기능 수정 요청
                });

                // list sort
                self.$solutionsSort.on('change', function() {
                    var value = $(this).val(),
                        param = {
                            page: 1,
                            sort: value
                        };
                        
                    $.extend(self.param, param);
                    self.requestData();
                });

                self.$solutionsVideo.on('click', function(e) {
                    var value = "";
                    if($(this).is(":checked") == true){
                        value = "Y";
                    }else{
                        value = "";
                    }
                    var param = {
                            page: 1,
                            video: value
                        };
                    $.extend(self.param, param);
                    self.requestData();

                }); 
                // pagination
                self.$solutionsResult.find('.pagination').on('pageClick', function(e) {
                    var param = {
                        page: e.page
                    }

                    $.extend(self.param, param);
                    self.requestData();
                });

                self.$keywordWrap.on('autocomplete', function(e, param, url, callback) {
                    $.extend(self.param, param);
                    lgkorUI.requestAjaxData(url, self.param, function(result) {
                        callback(result.data);
                    });
                    // self.downloadSearchChk();
                });

                self.$keywordWrap.find('.btn-list-all').on('click', function() {
                    self.$keywordBtn.trigger('click');
                });

                self.$solutionsWrap.find('#research').on('change', function() {
                    self.param.research = self.$solutionsWrap.find('#research').is(':checked');
                });
                
                self.$modelBox.on('change', '#subCategorySelect' , function() {   //보유 재품에서 카테고리 선택시 하단 활성화
                    // self.$contentsjobDiv.show();		//jslee 보유 제품 선텍시 바컨트롤
                    // self.setting();
                    
                    // BTOCSITE-55571 고객지원 > 스스로 해결 콘텐츠 Survey 화면 변경 및 데이터 Tracking
                    // $.extend(self.param, {
                    //     category:      $('#category').val(),
                    //     categoryNm:    $('#categoryNm').val(), 
                    //     subCategory:   $('#subCategory').val(),
                    //     subCategoryNm: $('#subCategoryNm').val(), 
                    //     modelCode:	   $('#modelCode').val(),
                    //     productCode:   $('#productCode').val(),
                    //     salesModelCode:$('#salesModelCode').val()
                    // });
                    
                    
                    
                    // self.$selectedModelBar.show(); // 플로팅바 노출
                    // self.completeModel();
                    // self.requestData();
                    self.$stepArea.show(); // 정보 입력창 노출
                    self.$myModelWrap.hide(); // 제품 리스트 은폐
                    // self.downloadSearchChk();
                    self.bannerToggle($('#subCategory').val()); // BTOCSITE-44508 노트북/PC용 통합 LG Update 배너 노출 추가 및 배너 시인성 강화
                    //$('#serviceMenu2').before($('.banner-wrap.toggle-banner'));

                });

				self.$modelBox.on('keyup', 'input[type=text]', function(e) {
					//영문이나 숫자로 이루어진 모델명을 2자 이상 입력해주세요.
					self.$modelBox.find('.search-error').html('영문이나 숫자로 이루어진 모델명을 2자 이상 입력해주세요.');
					self.$modelBox.find('.search-error').hide();
                    var searchVal = $('#search').val().toUpperCase();

					if (e.keyCode == 13) {  
						e.preventDefault();
						var chkdata = self.$modelBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
						if(chkdata.length > 0){
							chkdata.trigger('click');               
						}else{
							self.$modelBox.find('.search-error').html('"'+$('#search').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
							self.$modelBox.find('.search-error').show();
						}
					}
				});
				
				self.$modelBox.find('.btn-search').on('click', function(e){
					e.preventDefault();
                    var searchVal = $('#search').val().toUpperCase();
					var chkdata = self.$modelBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');

					if(chkdata.length > 0){
						chkdata.trigger('click');                     
					}else{
						self.$modelBox.find('.search-error').html('"'+searchVal+'"에 대한 검색 결과가 없습니다.')
						self.$modelBox.find('.search-error').show();
					}
				});
                

                // keyword input keypress enter
                self.$keywordInput.on('keyup', function(e){
                    if (e.keyCode == 13){
                        self.$keywordBtn.trigger('click');        
                    }
                });

                // keyword search
                self.$keywordBtn.on('click', function(e, keyword) {
                    var value = keyword || self.$keywordInput.val();
                    if (value.trim().length > 1) {
                        var data = $.extend({}, self.param),
                            isChecked = data.research;

                        data['page'] = 1;

                        if (!isChecked) {
                            self.resetFilter();
                            data['topic'] = '';
                            data['topicNm'] = '전체';
                            data['subTopic'] = '';
                            data['subTopicNm'] = '전체';
                            data['sympCodeThree'] = '';
                            data['sympNameThreeNm'] ='전체';
                            data['keywords'] = [];
                            data['keywords'].push(value);
                        } else {
                            if (data['keywords'].indexOf(value) != -1) {
                                data['keywords'].splice(data['keywords'].indexOf(value), 1);
                            }
                            data['keywords'].unshift(value);
                        }
                        $('input[name="topicrdo"]:checked').prop("checked",false);
                          $('.sub-topic').hide();
                        lgkorUI.setAcecounter('www.lge.co.kr/acecount/solutionsSearchClick.do', '/acecount/solutionsSearchClickm.do');
                        
                        self.param = data;
                        self.$keywordWrap.find('.search-more').show();
                        self.requestData();
                        
                    }
                });

                self.$keywordWrap.on('keywordClick', function() {
                    self.$keywordBtn.trigger('click', [self.$keywordInput.val().trim()]);
                });

                self.$keywordWrap.find('.autocomplete-box').on('click', 'a', function() {
                    e.preventDefault();
                    lgkorUI.setAcecounter('www.lge.co.kr/acecount/solutionsAutoClick.do', '/acecount/solutionsAutoClickm.do');
                });

                self.$keywordWrap.find('.recently-keyword').on('click', 'a', function() {
                    lgkorUI.setAcecounter('www.lge.co.kr/acecount/solutionsRecentClick.do', '/acecount/solutionsRecentClickm.do');
                });

                self.$keywordWrap.find('.popular-keyword').on('click', 'a', function() {
                    lgkorUI.setAcecounter('www.lge.co.kr/acecount/solutionsPopularClick.do', '/acecount/solutionsPopularClickm.do');
                });
                
                // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
                var $imgView = $('.btn-img-view');
                $('#select2').on('change', function(){

                    // 이미지가 없는 경우 no-img 삭제
                    if(!(lgkorUI.NO_IMAGE_MODEL_NAME != $imgView.find('img').attr('src'))) {
                        $imgView.find('img').removeClass('no-img');
                    }
                });

                // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
                $imgView.on('click', function(e) {
                    e.preventDefault();
                
                    if($(this).find('img').hasClass('no-img')) return;

                    var domain=location.origin;
                    var agent = navigator.userAgent;
                    var imgUrl=domain + $(this).attr('href');
                    var imgAlt = $(this).find('img').attr('alt');
                    if(!vcui.detect.isMobileDevice){
                        window.open(imgUrl, '', '');
                        return
                    }

                    var currOption = $('#select2 option:selected');
                    var popTitle = currOption.hasClass('placeholder') ? '모델명 확인 방법' : currOption.text();
                    var $zoomPopup = $('#imgZoomPopup');
                    var $zoomImg = $('#imgZoomPopup img');
                    $zoomImg.attr('src', imgUrl);
                    $zoomImg.attr('alt', imgAlt);

                    $zoomPopup.find('.tit').html('<span>'+popTitle+'</span>');
                    $zoomPopup.vcModal('open');
                });

                self.$prodSearchWrap.on('click', '.search-layer .autocomplete-box a', function(e) { 
                
                    var $this = $(this),
                        data = $this.data();
                    
                    // self.setting();
                    /* //BTOCSITE-3312 add */
                    self.param = $.extend(self.param, {
                        category: data.category,
                        subCategory: data.subCategory,
                        categoryNm: data.categoryNm,
                        subCategoryNm: data.subCategoryNm,
                        modelCode: data.modelCode,
                        productCode: data.productCode,
                        salesModelCode:	data.salesModelCode
                    });
                    
                    $('#category').val(data.category);
                    $('#categoryNm').val(data.categoryNm);
                    $('#subCategory').val(data.subCategory);
                    $('#subCategoryNm').val(data.subCategoryNm);
                    $('#modelCode').val(data.modelCode);
                    $('#productCode').val(data.productCode);
                    $('#salesModelCode').val(data.salesModelCode);
                    // self.completeModel();
                    // self.requestData();
                   
                    // self.onLoadTabControl();  //스스로 해결진입 기준으로 탭 표시
                });
                self.$bannerMenu.on('click', 'li a',function(){ 
                    $('#categorySelect').vcSelectbox('selectedIndex', 0, true);
                });
                
                self.$bannerMenu.find('.service-list').on('click', 'a', function(){
                    var url = $(this).attr('href');
                    var param = url.substr(url.indexOf('?'));
                    var data = history.state;
                    
                    url = location.pathname + param;
                    window.history.pushState('', '', url);
                });
                self.$bannerMenu2.find('.service-list').on('click', 'a', function(){
                    var url = $(this).attr('href');
                    var param = url.substr(url.indexOf('?'));
                    var data = history.state;
                    
                    url = location.pathname + param;
                    window.history.pushState('', '', url);
                });
                
            }
        }
        
        solutions.initialize();
    });
})();